<template>
  <div class="provider-pie-chart">
    <div v-if="loading" class="chart-loading">
      <el-icon class="is-loading"><i class="el-icon-loading"></i></el-icon>
      <span>数据加载中...</span>
    </div>
    <div v-else-if="!hasData" class="chart-empty">
      <i class="el-icon-pie-chart"></i>
      <span>暂无数据</span>
    </div>
    <div v-else ref="chart" class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'provider-pie-chart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },

  computed: {
    hasData() {
      return this.data && this.data.length > 0
    },

    chartData() {
      if (!this.hasData) return []

      return this.data.filter(item =>
        item.times && Number(item.times) > 0
      ).map(item => ({
        name: item.name,
        value: Number(item.times),
        successRate: Number(item.successRate || 0)
      }))
      .sort((a, b) => b.value - a.value)
    }
  },

  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (this.hasData && !this.chart) {
            this.initChart()
          } else if (this.chart) {
            this.renderChart()
          }
        })
      },
      deep: true
    },

    loading(newVal) {
      if (!newVal && this.hasData) {
        this.$nextTick(() => {
          if (!this.chart) {
            this.initChart()
          } else {
            this.renderChart()
          }
        })
      }
    }
  },

  mounted() {
    this.initChart()
    this.bindEvents()
  },

  beforeDestroy() {
    this.unbindEvents()
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    initChart() {
      if (!this.$refs.chart) return
      this.chart = echarts.init(this.$refs.chart)
      this.renderChart()
    },

    renderChart() {
      if (!this.hasData) {
        if (this.chart) {
          this.chart.dispose()
          this.chart = null
        }
        return
      }

      if (!this.chart) return

      // 颜色映射(按服务商配置统一的颜色)
      const colorMap = {
        '诺诺发票': '#667eea',
        '百旺发票': '#4facfe',
        '博思发票': '#5daf7f',
        '天财发票': '#fad961',
        '其他': '#fa7c91'
      }

      const option = {
        title: {
          text: '服务商使用分布',
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 16,
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const { name, value, data } = params
            return `
              <div>
                <strong>${name}</strong><br/>
                调用次数: <span style="color: #409EFF">${this.formatNumber(value)}</span><br/>
                成功率: <span style="color: #67C23A">${data.successRate}%</span><br/>
                占比: <span style="color: #E6A23C">${params.percent}%</span>
              </div>
            `
          }
        },
        legend: {
          orient: 'vertical',
          right: 20,
          top: 'center',
          itemWidth: 14,
          itemHeight: 14,
          textStyle: {
            fontSize: 12,
            color: '#666'
          }
        },
        series: [
          {
            name: '服务商使用量',
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['35%', '50%'],
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              formatter: '{d}%',
              fontSize: 12
            },
            data: this.chartData.map(item => ({
              name: item.name,
              value: item.value,
              successRate: item.successRate,
              itemStyle: {
                color: colorMap[item.name] || '#667eea'
              }
            }))
          }
        ]
      }

      this.chart.setOption(option, true)
    },

    bindEvents() {
      this.resizeHandler = () => {
        if (this.chart) {
          this.chart.resize()
        }
      }
      window.addEventListener('resize', this.resizeHandler)
    },

    unbindEvents() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
        this.resizeHandler = null
      }
    },

    formatNumber(num) {
      if (!num) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style scoped>
.provider-pie-chart {
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
  border-radius: 12px;
  padding: 8px;
}

.chart-container {
  width: 100%;
  height: 100%;
  min-height: 350px;
}

.chart-loading,
.chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 350px;
  color: #909399;
}

.chart-empty i {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/custom/components/stats/invoice-stats/components/provider-pie-chart.vue